<template>
  <main>
    <v-dialog max-width="max-content" v-model="detailsDialog">
      <v-card class="pt-6 pb-3 px-10">
        <ol class="ma-0 pa-0">
          <li class="mb-4">
            <h5>Registration</h5>
            <p class="mt-1 mb-0">
              Please make sure that you bring your identity card with you.
            </p>
          </li>
          <li class="mb-4">
            <h5>Meals SATURDAY</h5>
            <p class="mt-1 mb-0">- Coffe break: 13:20 - 14:20</p>
            <p class="mt-1 mb-0">- Dinner: 19:20 - 20:20</p>
          </li>
          <li class="mb-4">
            <h5>Parking</h5>
            <p class="mt-1 mb-0">City parking is available near the venue.</p>
          </li>
        </ol>
      </v-card>
    </v-dialog>
    <ConfirmationLayout :loading="loading" :is-success="isSuccess">
      <template v-slot:success>
        <p class="statusText">
          {{ registrationData.confirmationSuccessTitle }}
        </p>
        <p class="statusText statusTextEmail">
          {{ registrationData.confirmationSuccessEmailText.toString() }}
        </p>
        <p class="statusText">
          {{ registrationData.confirmationSuccessFooterText }}
        </p>
      </template>
      <template v-slot:error>
        <p class="statusText statusError">
          {{ registrationData.confirmationErrorStatus }}
        </p>
        <p v-if="!!statusText" class="statusText statusError">
          {{ errorMessage }}
        </p>
      </template>
    </ConfirmationLayout>
  </main>
</template>

<script>
import { fetchRegistrationStatus } from "@/api/registration";
import ConfirmationLayout from "@/components/confirmation-layout/ConfirmationLayout.vue";

export default {
  name: "RegistrationConfirmation",
  components: { ConfirmationLayout },
  computed: {
    sessionId() {
      return this.$route.query.sessionId;
    },
    registrationId() {
      return this.$route.query.registrationId;
    },
    registrationData() {
      return this.$t("registration");
    }
  },
  data: () => ({
    statusText: "",
    errorMessage: "",
    loading: false,
    isSuccess: null,
    detailsDialog: false
  }),
  mounted() {
    this.getRegistrationStatus();
  },
  methods: {
    async getRegistrationStatus() {
      this.loading = true;
      this.statusText = this.registrationData.confirmationCheckStatus;
      try {
        const response = await fetchRegistrationStatus(
          this.sessionId,
          this.registrationId
        );
        if (response) {
          this.isSuccess = true;
          this.statusText = this.registrationData.confirmationSuccessStatus;
        } else {
          this.isSuccess = false;
          this.statusText = this.registrationData.confirmationErrorStatus;
        }
      } catch (error) {
        this.isSuccess = false;
        this.statusText = this.registrationData.confirmationErrorStatus;
        this.errorMessage = error?.message ?? "";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";

.statusText {
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
  color: $second;
}

.statusText {
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
  color: $second;
}
.statusTextEmail {
  max-width: 400px;
}

.statusError {
  color: $danger;
}
</style>
